import React, {useState} from 'react';
import ConditionalRender from "../ConditionalRender";
import {Button, Col, Container, FormControl, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPen, faSave} from "@fortawesome/free-solid-svg-icons";

const ExtraColumn = ({extraKey, editable, onEdit}) => {

    const[editMode, setEditMode] = useState(false);
    const [key, setKey] = useState(extraKey);

    function handleEdit()
    {
        setEditMode(false);
        onEdit && onEdit({oldKey: extraKey, newKey: key});
    }

    return (
        <div className={'d-flex align-items-center'}>
            <ConditionalRender condition={!editMode}>
                <span>{extraKey}</span>
                <ConditionalRender condition={editable}>
                    <Button variant={'outline-secondary'}
                            className={'ms-1'}
                            size={"sm"}
                            style={{padding: '0px 4.5px'}}
                            onClick={() => setEditMode(true)}>
                        <FontAwesomeIcon icon={faPen} size={'xs'}/>
                    </Button>
                </ConditionalRender>
            </ConditionalRender>
            <ConditionalRender condition={editMode}>
                <Container className={'p-0'}>
                    <Row className={'align-items-center'}>
                        <Col>
                            <FormControl type={'text'}
                                         size={"sm"}
                                         value={key}
                                         onChange={(e) => setKey(e.target.value)}/>
                        </Col>
                        <Col md={4} className={'p-0'}>
                            <Button variant={'outline-success'}
                                    style={{padding: '2px 7px'}}
                                    onClick={handleEdit}>
                                <FontAwesomeIcon icon={faSave}/>
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </ConditionalRender>
        </div>
    );
};

export default ExtraColumn;